import checkRes from "../helpers/checkRes";
import { RequestLoginError, RequestLogicError, RequestSystemError } from "../core/RequestError";
import { createCgiHelper } from "./util";
var middlewareStack = [checkRes(function (res) {
  var key = Object.prototype.hasOwnProperty.call(res, 'ret_code') ? 'ret_code' : 'ret';
  res[key] = +res[key];
  console.log('createCgiHelper', res[key], res[key] === 0, res);

  if (res[key] === -10) {
    throw new RequestSystemError('comm_cgi未配置对应的spp服务', res[key], res);
  } else if (res[key] === -11) {
    throw new RequestLoginError();
  } else if (res[key] !== 0) {
    throw new RequestLogicError(res.msg, res[key], res);
  } else {
    return res;
  }
})];
/**
 * 支持两种调用方式
 * 1. commCgi(params) // 普通调用
 * 2. commCgi([retry(1)])(params) // 支持prepend一些中间件到默认中间件前面，比如重试
 */

export default createCgiHelper('https://vip.video.qq.com/fcgi-bin/comm_cgi', middlewareStack);